import React, { Component, createRef } from 'react';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { getAvailablePages, getPageLabel } from '../../services/pageNavigation';
const base = 'secondary-header';

@inject('LiveDispatchStore', 'UserStore', 'RiderAndOutletPartnerStore')

@observer
class DispatchHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldScroll: false,
            pages: [],
            openDropdown: null
        };
        this.containerRef = createRef();
        this.scrollAreaRef = createRef();
    }

    componentDidMount() {
        const {
            UserStore: { position },
        } = this.props;
        this.checkScrollConditionWithDelay();
        const pages = getAvailablePages(position);

        this.setState({pages: pages})

        this.storeInterval = setInterval(() => {
            this.checkScrollConditionWithDelay();
        }, 1000 * 60); // 1 minute
    }

    checkScrollConditionWithDelay = () => {
        // Delay to allow DOM to fully render
        setTimeout(() => {
            this.checkScrollCondition();
        }, 1000 * 3);
    }
    
    checkScrollCondition = () => {
        if (!this.containerRef.current || !this.scrollAreaRef.current) {
            return;
        }
        const containerWidth = this.containerRef.current.offsetWidth;
        const scrollAreaWidth = this.scrollAreaRef.current.scrollWidth;
    
        // If the scroll area is wider than the container, set scroll to true
        if (containerWidth && scrollAreaWidth) {
            if (scrollAreaWidth > containerWidth) {
                this.setState({ shouldScroll: true });
            } else {
                this.setState({ shouldScroll: false });
            }
        }
    }

    handleSetDate = (forceLatest, momentDate) => {
        const {
            LiveDispatchStore: { handleGetDispatches },
        } = this.props;
        const date = moment(momentDate).format('DD-MM-YYYY');

        handleGetDispatches(forceLatest, date);
    };

    handleToggleSwitch = () => {
        const {
            LiveDispatchStore: { setAutoPrint, isAutoPrint },
        } = this.props;
        setAutoPrint(!isAutoPrint);
    };

    handleClickOpenModal = () => {
        const { LiveDispatchStore } = this.props;
        LiveDispatchStore.recentlyClosedAggregatorStores = LiveDispatchStore.closedAggregatorStores;
    }

    handleSetPage = (page) => {
        const {
            history,
            UserStore: { setPage },
        } = this.props;
        this.setState({ openDropdown: null });
        setPage(page);
        history.push(`/${page}`);
    };

    handleToggleDropdown = (event) => {
        const target = event.target && event.target.nodeType === 3
            ? event.target.parentElement
            : event.target;

        if (target && target.closest && target.closest('.dropdown-content')) {
            return;
        }

        this.setState((prevState) => ({
            openDropdown: prevState.openDropdown === 'pages' ? null : 'pages',
        }));
    };

    render() {
        const {
            UserStore: {
                currentPage,
                handleSetFullscreen,
                isCurrentPageFullScreen,
                selectedHub
            },
            RiderAndOutletPartnerStore,
            location,
        } = this.props;

        const {
            shouldScroll,
            pages,
            openDropdown
        } = this.state;

        const { staffMembers } = RiderAndOutletPartnerStore;
        const hubName = selectedHub && selectedHub.pickupAddress && selectedHub.pickupAddress.name
            ? selectedHub.pickupAddress.name
            : '';
        const outletName = hubName.includes('@')
            ? hubName.split('@')[1]
            : hubName;
        const normalizedOutletName = outletName ? outletName.replace(/\s+/g, ' ').trim() : '';

        return (
            <div className={`${base}__wrapper bg--white`}>
                <div className={`${base} display--flex justify--space-between prl`} style={{paddingLeft: '22px'}}> 
                    <div
                        className={`${base}__left display--flex flex-align-items-center`}
                        style={{ flex: '1 1 auto', minWidth: 0 }}
                    >
                        <img src={"https://image.popcontent.link/pop_logo.png"}  style={{width: '70px'}}/>
                        <p className={`${base}__outlet-name`}>
                            {normalizedOutletName}
                        </p>
                        <div className={`${base}__staff_member_container`} ref={this.containerRef}>
                            <div className={`${base}__staff_member_scroll ${shouldScroll ? 'scroll-animation' : ''}`} 
                                ref={this.scrollAreaRef}
                            >
                                {staffMembers.map((staffMember) => (
                                    <div key={staffMember.name} className={`${base}__staff_member`}>
                                        {staffMember.rankShort && (
                                            <span
                                                className={`${base}__rank ${
                                                staffMember.rankShort.replace(/\s+/g, '').length > 2
                                                    ? `${base}__rank--long`
                                                    : ''
                                                }`}
                                            >
                                                {staffMember.rankShort}
                                            </span>
                                        )}
                                        <span className={`${base}__staff_member_name`}>
                                            {staffMember.name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className={'display--flex'}>
                        <Link
                            to={{
                                pathname: "/all-orders",
                                state: { from: location.pathname }
                            }}>
                            <button className={`${base}__view-all-orders mrm`} style={{marginTop: '13px'}}>
                                    View all orders
                                </button>
                        </Link>
                        <Link to="/hub-performance">
                            <button className={`${base}__view-all-orders mrm`} style={{marginTop: '13px'}}>
                                Performance
                            </button>
                        </Link>

                        {(currentPage === 'packing') && (
                            <button
                                className={`${base}__fullscreen_btn`}
                                onClick={() => handleSetFullscreen(!isCurrentPageFullScreen)}
                                style={{marginTop: '13px', height: '54px'}}
                            >
                                <img
                                    className="exit_fullscreen_icon"
                                    src={isCurrentPageFullScreen? "https://image.popcontent.link/exit-full-screen.png" : "https://image.popcontent.link/go_full_screen.png"}
                                    alt="Exit fullscreen"
                                />
                            </button>
                        )}
                        {isCurrentPageFullScreen && (
                            <div
                                className={`${base}__dropdown ${openDropdown === 'pages' ? 'is-open' : ''}`}
                                tabIndex={0}
                                onClick={this.handleToggleDropdown}
                            >
                                <span className={`${base}__dropdown-label`}>
                                    {getPageLabel(currentPage)}
                                </span>
                                <svg fill="#fff" className="iconmoon-icon">
                                    <use xlinkHref={`#icon-caret-down`} />
                                </svg>
                                <div className={`dropdown-content pages`}>
                                    {pages
                                        .filter((page) => page !== currentPage)
                                        .map((page, i) => (
                                            <a
                                                key={i}
                                                className="cursor-pointer"
                                                onClick={() =>
                                                    this.handleSetPage(page)
                                                }
                                            >
                                                {getPageLabel(page)}
                                            </a>
                                        ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(DispatchHeader);
